import { render, staticRenderFns } from "./goods-content.vue?vue&type=template&id=33788e4b"
import script from "./goods-content.vue?vue&type=script&lang=js"
export * from "./goods-content.vue?vue&type=script&lang=js"
import style0 from "./goods-content.vue?vue&type=style&index=0&id=33788e4b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports